export const menuData = [
  {
    id: 'pizzat',
    name: 'Pizzat',
    description: 'Norm / Perhe',
    items: [
      { name: 'EMILIANA', description: 'Jauheliha, mozzarella', price: '11,50 / 21,00€' },
      { name: 'TROPICANA', description: 'Kinkku, ananas', price: '12,00 / 22,00€' },
      { name: 'SALAMI PIZZA', description: 'Salami, paprika', price: '12,00 / 22,00€' },
      { name: 'PEPPERONI PIZZA', description: 'Pepperoni, tonnikala', price: '12,00 / 22,00€' },
      { name: 'AMERICANO', description: 'Kinkku, ananas, aurajuusto', price: '12,50 / 23,00€' },
      { name: 'OPERA SPECIAL', description: 'Kinkku, salami, tonnikala', price: '12,50 / 23,00€' },
      { name: 'CHICKEN HAWAII', description: 'Kana, ananas, aurajuusto', price: '12,50 / 23,00€' },
      { name: 'FRUTTI DI MARE', description: 'Tonnikala, katkarapu, simpukka', price: '12,50 / 23,00€' },
      { name: 'MARGARITA', description: 'Tomaatti, mozzarella, basilika', price: '12,50 / 23,00€' },
      { name: 'QUATRO', description: 'Kinkku, herkkusieni, tonnikala, katkarapu', price: '13,50 / 25,00€' },
      { name: 'DILLINGER', description: 'Kinkku, salami, jauheliha, sipuli', price: '13,50 / 25,00€' },
      { name: 'MEXICANA', description: 'Pepperoni, ananas, jalapeno, tacokastike', price: '13,50 / 25,00€' },
      { name: 'PEKONI PIZZA', description: 'Pekoni, salami, sipuli, kananmuna', price: '13,50 / 25,00€' },
      { name: 'REVONTULET SPECIAL', description: 'Kebab, ananas, aurajuusto, savuporo', price: '13,50 / 25,00€' },
      { name: 'BUONO', description: 'Pepperoni, kebab, aurajuusto, paprika', price: '13,50 / 25,00€' },
      { name: 'KASVIS PIZZA', description: 'Herkkusieni, oliivi, sipuli, paprika', price: '13,50 / 25,00€' },
      { name: 'TALON SPECIAL', description: 'Kebabliha, talon kastike, ranskalaiset ja salaatti', price: '13,50 / 25,00€' },
      { name: 'FINPOWER', description: 'Kebab, salami, kinkku, jauheliha', price: '13,50 / 25,00€' },
      { name: 'SUPER SALAMI', description: 'Kebab, salami, kinkku, aurajuusto', price: '13,50 / 25,00€' },
      { name: 'TAJU', description: 'Salami, feta, jalapeno, ananas, smetana', price: '14,00 / 26,00€' },
      { name: 'EMPIRE SPECIAL', description: 'Kinkku, salami, sipuli, katkarapu, valkosipuli', price: '14,00 / 26,00€' },
      { name: 'BBQ', description: 'Kana, sipuli, pekoni, mozzarella, BBQ-kastike', price: '14,00 / 26,00€' },
      { name: 'BOMBAI', description: 'Kana, ananas, tuore chili, curry-kastike, rukola', price: '14,00 / 26,00€' },
      { name: 'PARMIGIANA', description: 'Grillattu munakoiso, basilika, parmesaani, pesto, mozzarella', price: '14,00 / 26,00€' },
      { name: 'KEBAB PIZZA', description: 'Kebab, sipuli, chili, tomaatti, aurajuusto', price: '14,00 / 26,00€' },
      { name: 'VEGETALE', description: 'Pinaatti, tuore chili, feta, kirsikkatomaatti, pesto', price: '14,00 / 26,00€' },
      { name: 'DI CAPRA', description: 'Vuohenjuusto, paahdettu kesäkurpitsa, parmankinkku, kirsikkatomaatti, sipuli, pesto', price: '15,00 / 27,00€' },
      { name: 'SMETANA', description: 'Kebab, sipuli, chili, fetajuusto, tomaatti, smetana', price: '15,00 / 27,00€' },
      { name: 'DI PARMA', description: 'Parmankinkku, rucola, pesto, parmesaani, mozzarella, aurinkokuivattu tomaatti', price: '15,00 / 27,00€' },
    ],
  },
  {
    id: 'oma-valinta',
    name: 'Oma Valinta',
    items: [
      { name: '1 täyte', description: '', price: '11,00 / 20,00€' },
      { name: '2 täytettä', description: '', price: '12,00 / 22,00€' },
      { name: '3 täytettä', description: '', price: '13,00 / 24,00€' },
      { name: '4 täytettä', description: '', price: '14,00 / 25,00€' },
    ],
  },
  {
    id: 'snacks',
    name: '🍟 Snäks Ateriat',
    items: [
      { name: 'PIENET RANSKALAISET', description: '', price: '5,00€' },
      { name: 'ISOT RANSKALAISET', description: '', price: '7,00€' },
      { name: 'RISTIKKOPERUNAT', description: '', price: '8,00€' },
      { name: 'SIPULIRENKAAT', description: '5 kpl sipulirenkaita ja ranskalaiset', price: '8,00€' },
      { name: 'MOZZARELLATIKUT', description: '5 kpl mozzarellatikut ja ranskalaiset', price: '9,00€' },
      { name: 'KANAKORI', description: '5 kpl kananugetit, 2 sipulirengasta, 2 mozzarellatikkua, ranskalaiset, curry dippi', price: '13,00€' },
    ],
  },
  {
    id: 'salaatit',
    name: '🥗 Salaatit',
    items: [
      { name: 'FETASALAATTI', description: 'Feta, sipuli, oliivi, paprika, tomaatti, kurkku, sitruunainen oliiviöljykastike', price: '15,90€' },
      { name: 'TONNIKALA SALAATTI', description: 'Tonnikala, punasipuli, maissi, tomaatti, kurkku, sitruunainen oliiviöljykastike', price: '15,90€' },
      { name: 'CAESAR SALAATTI', description: 'Grillattu kana, krutonki, caesar-kastike, kirsikkatomaatti, parmesaani', price: '16,90€' },
      { name: 'VUOHENJUUSTOSALAATTI', description: 'Parmankinkku, grillattu vuohenjuusto, tummaleipä, tomaatti, kurkku, siemensekoitus, pesto, aurinkokuivattu tomaatti, parmesaani', price: '17,90€' },
    ],
  },
  {
    id: 'falafelit',
    name: '🧆 Falafelit',
    items: [
      { name: 'F1. FALAFEL LEIVÄLLÄ', description: '', price: '12,00€' },
      { name: 'F2. FALAFEL RIISILLÄ', description: '', price: '13,00€' },
      { name: 'F3. FALAFEL PERUNOILLA', description: 'Valitse lisuke: ranskalaiset, lohkoperunat, ristikkoperunat', price: '13,00€' },
      { name: 'F4. FALAFEL RULLA', description: '', price: '13,00€' },
    ],
  },
  {
    id: 'kana',
    name: '🍗 Kana Rintafileet',
    items: [
      { name: 'CURRYKANA', description: '200 g grillattu kanan rintafile, paistettu ananas, currykastike, kasvikset', price: '17,90€' },
      { name: 'KANA GORGONZOLA', description: '200 g grillattu kanan rintafile, gorgonzola kermakastike, kasvikset', price: '18,90€' },
      { name: 'PIPPURIKANA', description: '200 g grillattu kanan rintafile, pippuri kermakastike, kasvikset', price: '18,90€' },
      { name: 'VUOHENJUUSTOKANA', description: '200 g grillattu kanan rintafile, grillattu vuohenjuusto, paholaisen hillo, kasvikset', price: '18,90€' },
    ],
  },
  {
    id: 'pihvit',
    name: '🥩 Pihvit',
    items: [
      { name: 'LEHTIPIHVI', description: 'Naudan ulkofile, maustevoi, paistetut kasvikset', price: '19,00€' },
      { name: 'GRILLIPIHVI', description: 'Naudan ulkofile, maustevoi, paistetut kasvikset', price: '19,00€' },
      { name: 'SIPULIPIHVI', description: 'Naudan ulkofile, paistettu sipuli, paistetut kasvikset', price: '19,90€' },
      { name: 'PIPPURIPIHVI', description: 'Naudan ulkofile, pippurikastike, paistetut kasvikset', price: '20,90€' },
    ],
  },
  {
    id: 'leikkeet',
    name: '🍖 Leikkeet',
    items: [
      { name: 'HAWAINLEIKE', description: 'Paneroitu porsaan ulkofile, paistettu ananas, paistetut kasvikset', price: '16,90€' },
      { name: 'WIENERLEIKE', description: 'Paneroitu porsaan ulkofile, sitruuna, anjovis, paistetut kasvikset, kapris', price: '16,90€' },
      { name: 'METSÄSTÄJÄNLEIKE', description: 'Paistettu herkkusieni, kermakastike, paistetut kasvikset', price: '18,90€' },
      { name: 'AURAJUUSTOLEIKE', description: 'Aurajuusto, kermakastike, paistetut kasvikset', price: '18,90€' },
      { name: 'PIPPURILEIKE', description: 'Pippurikermakastike, paistetut kasvikset', price: '18,90€' },
      { name: 'SVEITSINLEIKE', description: 'Paneroitu porsaan ulkofile, täytetty kinkulla ja juustolla, paistetut kasvikset', price: '19,90€' },
    ],
  },
  {
    id: 'kebabit',
    name: '🥙 Kebabit',
    description: 'Kaikki sisältävät: salaatti, tomaatti, punasipuli, chili, kastikkeet',
    items: [
      { name: 'K1. Pitakebab', description: '', price: '12,00€' },
      { name: 'K2. Riisillä', description: '', price: '13,00€' },
      { name: 'K3. Ranskalaisilla', description: '', price: '13,00€' },
      { name: 'K4. Lohkoperunoilla', description: '', price: '13,00€' },
      { name: 'K5. Rulla', description: '', price: '13,00€' },
      { name: 'K6. Salaatilla', description: '', price: '13,00€' },
      { name: 'K7. Kermaperunoilla', description: '', price: '13,00€' },
      { name: 'K8. Iskender', description: '', price: '14,00€' },
      { name: 'K9. Valkosipuliperunoilla', description: '', price: '14,00€' },
      { name: 'K10. Juustoperunoilla', description: '', price: '14,00€' },
      { name: 'K11. Aurajuustoperunoilla', description: '', price: '14,00€' },
      { name: '+ Tuplaliha', description: '', price: '6,00€' },
    ],
  },
  {
    id: 'burgerit',
    name: '🍔 Burgerit',
    items: [
      { name: 'JUUSTO BURGER', description: '100 g pihvi, juusto, jääsalaatti, sipuli, tomaatti, suolakurkku', price: '10,00 / 13,50€' },
      { name: 'TUPLAJUUSTO BURGER', description: '190 g pihvi, juusto, sipuli, tomaatti, suolakurkku, jääsalaatti', price: '13,00 / 16,50€' },
      { name: 'CHILI BURGER', description: '190 g pihvi, juusto, chili, sipuli, tomaatti, suolakurkku, jääsalaatti', price: '13,50 / 17,00€' },
      { name: 'AURA PEKONI BURGER', description: '190 g pihvi, juusto, pekoni, kananmuna, sipuli, tomaatti, suolakurkku, jääsalaatti', price: '14,00 / 17,50€' },
      { name: 'KARTANON BURGER', description: '190 g pihvi, juusto, pekoni, kananmuna, sipuli, tomaatti, suolakurkku, jääsalaatti', price: '14,00 / 17,50€' },
      { name: 'KING BURGER', description: '190 g pihvi, vuohenjuusto, pekoni, BBQ-kastike, sipuli, tomaatti, suolakurkku, jääsalaatti', price: '14,50 / 18,00€' },
    ],
  },
  {
    id: 'hot-wings',
    name: '🍗 Hot Wings',
    items: [
      { name: '10 kpl', description: '', price: '12,50€' },
      { name: '14 kpl', description: '', price: '16,50€' },
      { name: '18 kpl', description: '', price: '20,00€' },
    ],
  },
  {
    id: 'lisukkeet',
    name: 'Lisukkeet',
    items: [
      { name: 'Ranskalaiset / lohkoperunat', description: '', price: '4,00€' },
      { name: 'Riisi / kermaperunat / ristikkoperunat / auraperunat / juustoperunat', description: '', price: '6,00€' },
    ],
  },
  {
    id: 'juomat',
    name: '🥤 Juomat',
    items: [
      { name: '0,33 l limu', description: '', price: '3,00€' },
      { name: '0,50 l limu', description: '', price: '4,00€' },
      { name: '1 l maito', description: '', price: '3,00€' },
      { name: 'Kahvi / tee', description: '', price: '2,50€' },
      { name: '1,5 l limu', description: '', price: '6,00€' },
    ],
  },
  {
    id: 'lapsille',
    name: '👶 Lapsille',
    items: [
      { name: 'LASTEN PIZZA', description: '2 täytteellä', price: '10,00€' },
      { name: 'JUUSTOBURGER', description: '100 g pihvi, juusto, sipuli, tomaatti, suolakurkku, jääsalaatti', price: '10,00€' },
      { name: 'NUGETIT RANSKALAISILLA', description: '5 kpl nugetteja, curry dippi', price: '10,00€' },
      { name: 'MAKKARAPERUNAT', description: '100 g makkara ja ranskalaiset', price: '10,00€' },
    ],
  },
  {
    id: 'lisataytteet',
    name: '➕ Lisätäytteet',
    items: [
      { name: 'Lisätäyte', description: 'Kebab, salami, kinkku, pepperoni, pekoni, tonnikala, jauheliha, jalapeno, chili, aurajuusto, feta, mozzarella, vihannekset, jne.', price: '1,50 / 3,00€' },
    ],
  },
];
